import React, { useState } from 'react';
import apiClient from '../../api/apiClient';
import { X, Loader2 } from 'lucide-react';

const ChargeRequestModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    full_name: '',
    phone_number: '',
    amount: '',
    location: 'iran',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    try {
      const response = await apiClient.post('/wallet/charge-request/', formData);
      setMessage({ type: 'success', text: response.data.message });
      setTimeout(() => {
        onClose();
        setFormData({ full_name: '', phone_number: '', amount: '', location: 'iran' });
        setMessage(null);
      }, 3000);
    } catch (err) {
      setMessage({ type: 'error', text: 'خطا در ثبت درخواست. لطفاً دوباره تلاش کنید.' });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6 rtl relative">
        <button onClick={onClose} className="absolute left-4 top-4 text-gray-500 hover:text-gray-800">
          <X size={24} />
        </button>
        <h2 className="text-xl font-bold mb-4 text-center">درخواست شارژ کیف پول</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">نام و نام خانوادگی</label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-purple-500 focus:border-purple-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">شماره تماس</label>
            <input
              type="tel"
              name="phone_number"
              value={formData.phone_number}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">مبلغ (تومان)</label>
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              required
              min="1000"
              step="1000"
              className="w-full border border-gray-300 rounded-lg px-3 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">موقعیت مکانی</label>
            <div className="flex gap-4">
              <label className="flex items-center">
                <input
                  type="radio"
                  name="location"
                  value="iran"
                  checked={formData.location === 'iran'}
                  onChange={handleChange}
                  className="ml-2"
                />
                داخل ایران
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name="location"
                  value="outside"
                  checked={formData.location === 'outside'}
                  onChange={handleChange}
                  className="ml-2"
                />
                خارج ایران
              </label>
            </div>
          </div>
          {message && (
            <div className={`p-2 rounded text-center text-sm ${message.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
              {message.text}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-purple-700 text-white py-2 rounded-lg hover:bg-purple-800 transition flex items-center justify-center gap-2 disabled:opacity-70"
          >
            {loading && <Loader2 className="animate-spin" size={18} />}
            {loading ? 'در حال ثبت...' : 'ثبت درخواست'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChargeRequestModal;